import { DataCollection } from "../datacollection";
import { dhxError, dhxWarning, isEqualObj, toDataDriver, hasJsonOrArrayStructure } from "../helpers";
import {DataEvents, Id, IDataDriver, IDataProxy} from "../types";

export class Loader {
	private _parent: DataCollection;
	private _saving: boolean;
	private _changes: any;
	constructor(parent: DataCollection, changes: any) {
		this._parent = parent;
		this._changes = changes;// todo: [dirty] mutation
	}
	load(url: IDataProxy, driver?: IDataDriver): Promise<any> {
		return this._parent.loadData = url.load().then((data) => {
			this._parent.removeAll();
			// const parcedData = this.parse(data, driver);
			return this.parse(data, driver);
		}).catch((error) => {
			this._parent.events.fire(DataEvents.loadError, [error]);
		});
	}
	parse(data: any[], driver: any = "json") {
		if (driver === "json" && !hasJsonOrArrayStructure(data)) {
			this._parent.events.fire(DataEvents.loadError, ["Uncaught SyntaxError: Unexpected end of input"]);
		}
		driver = toDataDriver(driver);
		data = driver.toJsonArray(data);
		this._parent.$parse(data);
		return data;
	}

	save(url: IDataProxy) {
		for (const el of this._changes.order) {
			if (el.saving || el.pending) {
				dhxWarning("item is saving");
			} else {
				const prevEl = this._findPrevState(el.id);

				if (prevEl && prevEl.saving) {
					const pending = new Promise((res, rej) => {
						prevEl.promise.then(() => {
							el.pending = false;
							res(this._setPromise(el, url));
						}).catch(err => {
							this._removeFromOrder(prevEl);
							this._setPromise(el, url);
							dhxWarning(err);
							rej(err);
						});
					});
					this._addToChain(pending);
					el.pending = true;
				} else {
					this._setPromise(el, url);
				}
			}
		}
		this._parent.saveData.then(() => {
			this._saving = false;
		});
	}
	private _setPromise(el, url): Promise<any> {
		el.promise = url.save(el.obj, el.status);
		el.promise.then(() => {
			this._removeFromOrder(el);
		}).catch(err => {
			el.saving = false;
			el.error = true;
			dhxError(err);
		});
		el.saving = true;
		this._saving = true;
		this._addToChain(el.promise);
		return el.promise;
	}
	private _addToChain(promise): void {
		// tslint:disable-next-line:prefer-conditional-expression
		if (this._parent.saveData && this._saving) {
			this._parent.saveData = this._parent.saveData.then(() => promise);
		} else {
			this._parent.saveData = promise;
		}
	}
	private _findPrevState(id: Id): any {
		for (const el of this._changes.order) {
			if (el.id === id) {
				return el;
			}
		}
		return null;
	}
	private _removeFromOrder(el) {
		this._changes.order = this._changes.order.filter(item => !isEqualObj(item, el));
	}
}